module.exports = __webpack_public_path__ + "img/next.8a8f5fc6.png";